var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "containerRef",
    staticClass: "linkBoard relative w-full h-full overflow-visible",
    staticStyle: {
      "width": "min(96vw, 400px)",
      "height": "min(96vw, 400px)"
    }
  }, [_c('svg', {
    staticClass: "absolute inset-0 pointer-events-none z-10 w-full h-full"
  }, [_vm.lineCoords ? _c('path', {
    staticClass: "line-animation",
    attrs: {
      "d": _vm.lineCoords,
      "fill": "none",
      "stroke": "#6366f1",
      "strokeWidth": "4",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "grid h-full",
    style: {
      gridTemplateColumns: `repeat(${_vm.grid[0].length}, 1fr)`,
      gridTemplateRows: `repeat(${_vm.grid.length}, 1fr)`
    }
  }, _vm._l(_vm.flatGrid, function (tile) {
    return _c('LinkTile', {
      key: `${tile.x}-${tile.y}`,
      attrs: {
        "tile": tile,
        "isSelected": _vm.gameState.selectedTile?.id === tile.id,
        "isHinted": _vm.gameState.hintPath?.some(p => p.x === tile.x && p.y === tile.y) || false,
        "iconSet": _vm.iconSet
      },
      on: {
        "onClick": _vm.handleClick
      }
    });
  }), 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };